import { defineComponent } from '@vue/composition-api';
import __vue_component__$1 from '../SdsButtonIcon/SdsButtonIcon.vue.js';
import __vue_component__$2 from '../SdsButtonText/SdsButtonText.vue.js';
import __vue_component__ from '../SdsIcon/SdsIcon.vue.js';

var script = defineComponent({
    name: 'SdsSnackbar',
    props: {
        iconName: {
            type: String,
            required: false,
            default: undefined,
        },
        title: {
            type: String,
            required: false,
            default: undefined,
        },
        message: {
            type: String,
            required: false,
            default: undefined,
        },
        buttonText: {
            type: String,
            required: false,
            default: undefined,
        },
        hasClose: {
            type: Boolean,
            required: false,
            default: false,
        },
        stickToTop: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    emits: [
        'button:click',
        'close',
    ],
    components: {
        SdsIcon: __vue_component__,
        SdsButtonIcon: __vue_component__$1,
        SdsButtonText: __vue_component__$2,
    },
});

export default script;
